import React from 'react';
import PropTypes from 'prop-types';
import { StyledCard } from './Card.styles';
import { CardProps } from './types';

export const Card = ({
  children,
  color = 'default',
  disabled = false,
  padding = 'default',
  onClick,
  className,
  ...props
}: CardProps) => {
  const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.code === 'Enter') {
      onClick && onClick();
    }
  };

  const interactableProps = { onClick, onKeyDown: handleOnKeyDown, tabIndex: 0, role: 'button' };

  return (
    <StyledCard
      padding={padding}
      color={color}
      disabled={disabled}
      className={className}
      {...(!disabled && onClick ? { ...interactableProps } : {})}
      {...props}
    >
      {children}
    </StyledCard>
  );
};

Card.propTypes = {
  children: PropTypes.node,
  padding: PropTypes.oneOf(['default', 'large', PropTypes.number] as const),
  color: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};
